import { GET_ORDER_ITEMS_REQUEST, GET_ORDER_ITEMS_SUCCESS, GET_ORDER_ITEMS_FAILURE, GET_ORDER_ITEM_REQUEST, GET_ORDER_ITEM_SUCCESS, GET_ORDER_ITEM_FAILURE, ADD_ORDER_ITEM_REQUEST, ADD_ORDER_ITEM_SUCCESS, ADD_ORDER_ITEM_FAILURE, UPDATE_ORDER_ITEM_REQUEST, UPDATE_ORDER_ITEM_SUCCESS, UPDATE_ORDER_ITEM_FAILURE, DELETE_ORDER_ITEM_REQUEST, DELETE_ORDER_ITEM_SUCCESS, DELETE_ORDER_ITEM_FAILURE } from '../constants';
 
export default (state = {}, action) => {
  switch (action.type) {
    case GET_ORDER_ITEMS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case GET_ORDER_ITEMS_SUCCESS:
      return {
        loading: false,
        items: action.orderItems.orderItems,
        total: action.orderItems.total
      };
    case GET_ORDER_ITEMS_FAILURE:
      return {
        error: action.error
      };
    case GET_ORDER_ITEM_REQUEST:
      return {
        loading: true,
        item: null
      };
    case GET_ORDER_ITEM_SUCCESS:
      return {
        loading: false,
        item: action.orderItem
      };
    case GET_ORDER_ITEM_FAILURE:
      return {
        error: action.error
      };
    case ADD_ORDER_ITEM_REQUEST:
      return {
        loading: true,
        error: '',
        success: false,
      };
    case ADD_ORDER_ITEM_SUCCESS:
      return {
        loading: false,
        success: true,
        error: ''
      };
    case ADD_ORDER_ITEM_FAILURE:
      return {
        error: action.error,
        loading: false,
        success: false
      };
    case UPDATE_ORDER_ITEM_REQUEST:
      return {
        loading: true,
        error: '',
        success: false,
      };
    case UPDATE_ORDER_ITEM_SUCCESS:
      return {
        loading: false,
        success: true,
        error: ''
      };
    case UPDATE_ORDER_ITEM_FAILURE:
      return {
        error: action.error,
        loading: false,
        success: false
      };
    case DELETE_ORDER_ITEM_REQUEST:
      // add 'deleting:true' property to orderItem being deleted
      return {
        ...state,
        items: state.items.map(orderItem =>
          orderItem.id === action.id
            ? { ...orderItem, deleting: true }
            : orderItem
        )
      };
    case DELETE_ORDER_ITEM_SUCCESS:
      // remove deleted orderItem from state
      return {
        items: state.items.filter(orderItem => orderItem.id !== action.id)
      };
    case DELETE_ORDER_ITEM_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to orderItem 
      return {
        ...state,
        items: state.items.map(orderItem => {
          if (orderItem.id === action.id) {
            // make copy of orderItem without 'deleting:true' property
            const { deleting, ...orderItemCopy } = orderItem;
            // return copy of orderItem with 'deleteError:[error]' property
            return { ...orderItemCopy, deleteError: action.error };
          }
 
          return orderItem;
        })
      };
    default:
      return state
  }
}